<section class="wo-trail" [attr.aria-busy]="loading" [attr.aria-label]="'What\'s On at ' + (businessName || 'this restaurant')">
  <ol class="wo-list" *ngIf="posts.length">
    <li class="wo-item" *ngFor="let post of posts; trackBy: trackById">
      <span class="wo-marker" aria-hidden="true"></span>
      <article class="wo-post" [class.wo-post--no-image]="!showImage(post)">
        <span class="wo-media" *ngIf="showImage(post)">
          <img [src]="post.image!.mobile" [alt]="post.image!.altText || post.title" loading="lazy" decoding="async"
               width="200" height="300" (error)="onImageError(post)" />
        </span>
        <div class="wo-copy">
          <div class="wo-meta" *ngIf="post.badge || post.availabilityText">
            <span class="wo-tag" *ngIf="post.badge">{{ post.badge }}</span>
            <span class="wo-when" *ngIf="post.availabilityText">{{ post.availabilityText }}</span>
          </div>
          <h4 class="wo-title">{{ post.title }}</h4>
          <p class="wo-intro" *ngIf="post.lead">{{ post.lead }}</p>
          <div class="wo-body" *ngIf="post.body.length" [id]="'whats-on-body-' + post.id"
               [class.wo-body--clamped]="isCollapsible(post) && !isExpanded(post)">
            <p *ngFor="let paragraph of post.body">{{ paragraph }}</p>
          </div>
          <button *ngIf="isCollapsible(post)" type="button" class="wo-toggle" (click)="toggle(post)"
                  [attr.aria-expanded]="isExpanded(post)" [attr.aria-controls]="'whats-on-body-' + post.id">
            {{ isExpanded(post) ? 'Show less' : 'Read more' }}
          </button>
        </div>
      </article>
    </li>
  </ol>

  <ol class="wo-list" *ngIf="loading && !posts.length" aria-hidden="true">
    <li class="wo-item" *ngFor="let row of skeletonRows">
      <span class="wo-marker"></span>
      <div class="wo-post">
        <span class="wo-media business-content-skeleton"></span>
        <div class="wo-copy">
          <span class="wo-skeleton-line business-content-skeleton" style="width: 30%"></span>
          <span class="wo-skeleton-line business-content-skeleton" style="width: 70%; height: 18px"></span>
          <span class="wo-skeleton-line business-content-skeleton" style="width: 90%"></span>
        </div>
      </div>
    </li>
  </ol>

  <p class="wo-state" *ngIf="!loading && !error && !posts.length">Nothing on right now. Check back soon.</p>

  <div class="wo-state wo-state--error" *ngIf="error" role="alert">
    <span>What's On couldn't load.</span>
    <button type="button" class="wo-more" (click)="retry()">Try again</button>
  </div>

  <div class="wo-footer" *ngIf="posts.length && (hasMore || (loading && posts.length))">
    <button type="button" class="wo-more" (click)="loadMore()" [disabled]="loading">
      {{ loading ? 'Loading…' : 'Show more' }}
    </button>
  </div>
</section>
